import { point_center, point_distance } from "./Vector";
export const initialPinchZoom = {
    active: false,
    // alle Points in der Längeneinheit des Systems s (SVG-Element)
    pos1: { x: 0, y: 0 },
    pos2: { x: 0, y: 0 },
    initialScale: 1,
    initialTranslate: { x: 0, y: 0 },
    pinchFocus: { x: 0, y: 0 },
};
export function pinchZoom_start(pos1, pos2, scale, translation) {
    return {
        active: true,
        pos1: pos1,
        pos2: pos2,
        initialScale: scale,
        initialTranslate: translation,
        pinchFocus: point_center(pos1, pos2),
    };
}
// pos1, pos2: Positionen, an denen sich die beiden Finger gerade befinden
// pos1, pos2: in der Längeneinheit des Systems s (SVG-Element)
export function pinchZoom_execute(pinchZoom, pos1, pos2) {
    const focus = pinchZoom.pinchFocus;
    // Scale
    // initialDistance in der Längeneinheit von s
    const initialDistance = point_distance(pinchZoom.pos1, pinchZoom.pos2);
    // newDistance in der Längeneinheit von s
    const newDistance = point_distance(pos1, pos2);
    // console.log(initialDistance, ' ', newDistance)
    const scaleChangeFactor = newDistance / initialDistance;
    const newScalePropoasal = Math.round(pinchZoom.initialScale * scaleChangeFactor);
    const newScale = newScalePropoasal < 25
        ? 25
        : newScalePropoasal < 200
            ? newScalePropoasal
            : 200;
    const deltaTranslationScaleX = (1 - newScale / pinchZoom.initialScale) * (focus.x - pinchZoom.initialTranslate.x);
    const deltaTranslationScaleY = (1 - newScale / pinchZoom.initialScale) * (focus.y - pinchZoom.initialTranslate.y);
    // Translation
    const newCenter = point_center(pos1, pos2);
    // const initialCenter = uiStateSubscription.pinchZoom.pinchFocus;
    const initialCenter = point_center(pinchZoom.pos1, pinchZoom.pos2);
    const deltaTranslationTranslateX = (newCenter.x - initialCenter.x);
    const deltaTranslationTranslateY = (newCenter.y - initialCenter.y);
    return {
        scale: newScale,
        translate: {
            x: pinchZoom.initialTranslate.x + deltaTranslationScaleX + deltaTranslationTranslateX,
            y: pinchZoom.initialTranslate.y + deltaTranslationScaleY + deltaTranslationTranslateY,
        }
        // translateX: pinchZoom.initialTranslate.x + deltaTranslationScaleX + deltaTranslationTranslateX,
        // translateY: pinchZoom.initialTranslate.y + deltaTranslationScaleY + deltaTranslationTranslateY,
    };
}
